// src/apiFetch.js
import { auth } from "./firebase-config";
import { BASE_URL } from "./config";

export async function apiFetch(path, options = {}) {
    const user = auth.currentUser;
    const token = user ? await user.getIdToken(true) : null;

    const headers = {
        ...(options.headers || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    return fetch(`${BASE_URL}${path}`, {
        ...options,
        headers,
    });
}
